<!-- <div class="d-flex justify-content-center d-inline"> -->
  <!-- <p>{{copy}}</p> -->
  <button class="btn btn-outline-success ml-3 copy-btn" type="button" [attr.name]="'copy-' + copy"  aria-label="copy"
    [attr.id]="'copy-' + copy" [cdkCopyToClipboard]="copy" (cdkCopyToClipboardCopied)="copyToClipBoard(copy)"
    [pTooltip]="copiedMap[copy] && !hideMap[copy] ? 'Copied' : 'Copy'" tooltipPosition="top">

    <i *ngIf="!copiedMap[copy]" class="pi pi-copy"></i>
    <i *ngIf="copiedMap[copy] && !hideMap[copy]" class="pi pi-check text-success"></i>
  </button>
<!-- </div> -->
